import React, { useEffect } from 'react';
import HeroSection from './HeroSection';
import RoughToPolishSection from './RoughToPolishSection';
import FoundationSection from './FoundationSection';
import DiamondSection from './DiamondSection';
import ArtisanSection from './ArtisanSection';
import GradingSystemSection from './GradingSystemSection';
import GlobalMomentsSection from './GlobalMomentsSection';
import NewsSection from './NewsSection';
import TestimonialsSection from './TestimonialsSection';
import LeadershipSection from './LeadershipSection';
import ContactSection from './ContactSection';
import './HomePage.css';

const HomePage: React.FC = () => {
  useEffect(() => {
    const allSections: HTMLElement[] = Array.from(document.querySelectorAll('.homepage > section'));
    if (!allSections.length) return;
    // Mark all (except hero) as fx-ready so CSS can target their children only.
    allSections.forEach((sec, idx) => {
      if (idx === 0) { // assume first is hero - show immediately
        sec.classList.add('shown');
      } else {
        sec.classList.add('fx-ready');
      }
    });
    if (!('IntersectionObserver' in window)) {
      allSections.forEach(s => s.classList.add('shown'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('shown');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    allSections.slice(1).forEach(sec => io.observe(sec));
    return () => io.disconnect();
  }, []);
  return (
    <div className="homepage">
      <HeroSection />
      <RoughToPolishSection />
      <FoundationSection />
      <DiamondSection />
      <ArtisanSection />
      <GradingSystemSection />
      <GlobalMomentsSection />
      <LeadershipSection />
      <ContactSection />
      <TestimonialsSection />
      {/* <NewsSection /> */}
    </div>
  );
};

export default HomePage;
